import css from '../WalletTicketDesktop.module.scss'
import React from 'react'

import DataTestId from 'meta/dataTestId'
import { Breakpoints } from 'meta/layout/breakpoints'
import { IEventData } from 'meta/pages/v4/event'
import { IWalletEvent } from 'meta/pages/v4/wallet'

import { GridColumn } from 'components/Layout/Grid'
import { useWalletEventTicketCodes } from 'hooks/useWallet'

import UserTicketContainer from '../UserTicket/UserTicketContainer'
import { UserTicketSkeleton } from '../UserTicket/UserTicketSkeleton'

interface Props {
  walletEventData: IWalletEvent
  eventData: IEventData
}

const UserTickets: React.FC<Props> = (props) => {
  const { walletEventData, eventData } = props
  const { id, count } = walletEventData

  const eventTicketCodesData = useWalletEventTicketCodes({ eventIdOrCodeUrl: String(id) })

  return (
    <GridColumn
      gridColumnStart={{ [Breakpoints.laptop]: 2 }}
      gridColumnEnd={{ [Breakpoints.laptop]: 16 }}
      className={css.walletTicket__tickets}
      data-testid={DataTestId.wallet.userTicketsDesktopContainer}
    >
      {!eventTicketCodesData && <UserTicketSkeleton />}
      {eventTicketCodesData &&
        eventTicketCodesData.length > 0 &&
        eventTicketCodesData.map((elem, key) => (
          <React.Fragment key={key}>
            <UserTicketContainer cod={elem.cod} walletEventData={walletEventData} eventData={eventData} idx={key} />
            {key !== count - 1 && <div className={css.walletTicket__cover} />}
          </React.Fragment>
        ))}
    </GridColumn>
  )
}

export default UserTickets
